import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import metadata from './BusinessOperationComponent.metadata.json5';

import styles from '../ITProfessional.module.scss';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function BusinessOperationComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('BusinessOperationComponent');
    const modelVM = _.get(submissionVM, pathUpdated)

    modelVM.value.isValidationReq = true


    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        ifOthPleDes8: {
            visible: !_.isUndefined(modelVM.comStr7.value) && modelVM.comStr7.value.code === 'Oth'
        },
        ifYesPleProFulDet19: {
            visible: !_.isUndefined(modelVM.hasTheComItsParDirOr18.value) && modelVM.hasTheComItsParDirOr18.value
        },
        doYouOrAnyLivUndYou20: {
            visible: !_.isUndefined(modelVM.doYouOrAnyLivUndYouVisible.value) && modelVM.doYouOrAnyLivUndYouVisible.value
        },
        ifYesPleDes23:{
            visible: !_.isUndefined(modelVM.areTheComItsParDirOff22.value) && modelVM.areTheComItsParDirOff22.value
        },
        ifYesPleDes25:{
            visible: !_.isUndefined(modelVM.isTheComItsParDirOff24.value) && modelVM.isTheComItsParDirOff24.value
        },
        ifYesPleDes27:{
            visible: !_.isUndefined(modelVM.isTheComParDirOffOr26.value) && modelVM.isTheComParDirOffOr26.value
        },
        sinItSLes3YeaDoe6: {
            visible: !_.isUndefined(modelVM.value.datEst5) && (new Date().getFullYear() - modelVM.value.datEst5.year) < 3,
            required: !_.isUndefined(modelVM.value.datEst5) && (new Date().getFullYear() - modelVM.value.datEst5.year) < 3
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

BusinessOperationComponent.propTypes = wizardProps;
export default withRouter(BusinessOperationComponent);
